export default __webpack_public_path__ + "static/media/reply-received-colored.09498266.svg";